import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import type { EmployeeSchedules } from "@/pages/human-resources/time-management/business/EmployeeSchedules.ts";

export default function useVisibleDraftSchedules(): Schedule[] {
  return filterDraftSchedules(useVisibleEmployeesSchedules());
}

export function filterDraftSchedules(
  employeesSchedules: EmployeeSchedules[],
): Schedule[] {
  return employeesSchedules
    .flatMap((es) => es.getMainSchedules())
    .filter((s) => s.modified);
}
